import {
	Box,
	Button,
	Flex,
	Heading,
	Table,
	TableContainer,
	Tbody,
	Td,
	Text,
	Th,
	Thead,
	Tr,
	useDisclosure,
} from '@chakra-ui/react';
import ActualizacionModal from '../Modals/Actividades/ActualizacionModal';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MultiActividad from '../MultiActividad/MultiActividad';
import PopoverDescripcion from './PopoverDescripcion';
import EasyDatePicker from '../EasyDatePicker/EasyDatePicker';
import PropuestaModal from '../Modals/Actividades/PropuestaModal';
import FirmaNotariaModal from '../Modals/Actividades/FirmaNotariaModal';

const ListaActividadesPedidos = ({ actividades, datos, pedidoAbierto = false }) => {
	const [datosRecibidos, setDatosRecibidos] = useState(datos);
	const [isEdit, setIsEdit] = useState(false);
	const navigate = useNavigate();

	const { isOpen: isOpenActualizacion, onOpen: onOpenActualizacion, onClose: onCloseActualizacion } = useDisclosure();
	const { isOpen: isOpenMultiActividad, onOpen: onOpenMultiActividad, onClose: onCloseMultiActividad } = useDisclosure();
	const { isOpen: isOpenPropuesta, onOpen: onOpenPropuesta, onClose: onClosePropuesta } = useDisclosure();
	const { isOpen: isOpenNotaria, onOpen: onOpenNotaria, onClose: onCloseNotaria } = useDisclosure();

	const handleOpenActividad = actividad => {
		setIsEdit(true);
		setDatosRecibidos({
			...actividad,
			tipo_inmueble: datos.tipo_inmueble,
			subtipo_inmueble: datos.subtipo_inmueble,
		});
		onOpenMultiActividad();
	};

	const handleNuevaActualizacion = () => {
		setIsEdit(false);
		setDatosRecibidos(datos);
		onOpenActualizacion();
	};

	const buildPayloadForModals = () => {
		const inmuebleUuid =
			datos?.inmueble?.uuid ||
			datos?.inmuebleUuid ||
			datos?.encargo?.inmueble?.uuid ||
			datos?.pedido?.inmueble?.uuid ||
			undefined;

		let ubicacion =
			datos?.inmueble?.ubicacion ||
			datos?.ubicacion ||
			datos?.encargo?.inmueble?.ubicacion ||
			datos?.pedido?.inmueble?.ubicacion ||
			undefined;

		console.log("Datos pedido", datos);

		if(!ubicacion) {
			// Concatenar provincia + localidad + codigo postal
			const localidad = datos?.localidad || datos?.pedido?.localidad || datos?.encargo?.inmueble?.localidad || '';
			const codigo_postal = datos?.codigo_postal || datos?.pedido?.codigo_postal || datos?.encargo?.inmueble?.codigo_postal || '';
			const merge = `${localidad}, CP ${codigo_postal}`;
			ubicacion = JSON.stringify({ direccion: merge });
		}

		const tipoInmueble =
			datos?.tipo_inmueble ||
			datos?.pedido?.tipo_inmueble ||
			datos?.encargo?.inmueble?.tipo_inmueble ||
			'';
		const subtipoInmueble =
			datos?.subtipo_inmueble ||
			datos?.pedido?.subtipo_inmueble ||
			datos?.encargo?.inmueble?.subtipo_inmueble ||
			'';

		const inmueble = {
			tipo_inmueble: tipoInmueble,
			subtipo_inmueble: subtipoInmueble,
			ubicacion,
			uuid: inmuebleUuid,
		};

		const pedidoUuid = datos?.pedidoUuid || datos?.uuid || datos?.pedido?.uuid;

		return {
			entidad_relacionada: 'Pedido',
			pedidoUuid,
			inmuebleUuid: inmuebleUuid,
			pedido: {
				tipo_inmueble: tipoInmueble,
				subtipo_inmueble: subtipoInmueble,
			},
			inmueble,
			encargosSeleccionados: datos.encargosSeleccionados || [],
		};
	};

	const handleOpenPropuesta = () => {
		setIsEdit(false);
		const payload = buildPayloadForModals();
		setDatosRecibidos({
			...datos,
			...payload,
		});
		onOpenPropuesta();
	};

	const handleOpenNotaria = () => {
		setIsEdit(false);
		const payload = buildPayloadForModals();
		setDatosRecibidos({
			...datos,
			...payload,
		});
		onOpenNotaria();
	};

	const tieneRealizadas = type => {
		return (
			actividades &&
			actividades.some(
				actividad => actividad.tipo_actividad === type && actividad.estado_actividad === 'Realizada',
			)
		);
	};

	const checkLlamadaPromocion = tieneRealizadas('Actualizacion');
	const checkCitaVentaAlquiler = tieneRealizadas('Promocion');
	const checkCitaPropuesta = tieneRealizadas('Venta o alquiler');
	const checkCitaNotaria = tieneRealizadas('Propuesta');

	return (
		<>
			<Box p={8} border='1px' rounded='md' shadow='dark-lg'>
				<Heading textAlign='center' mb={4}>Actividades</Heading>
				{pedidoAbierto && (
					<Flex>
						<Button rounded='none' w='100%' colorScheme='blue' onClick={handleNuevaActualizacion}>
							Llamada de actualización
						</Button>

						{checkLlamadaPromocion && (
							<Button
								rounded='none'
								w='100%'
								colorScheme='yellow'
								onClick={() => navigate(`/cruce/pedido/promocion/${datos.uuid}`)}
							>
								Llamada de promoción
							</Button>
						)}

						{checkCitaVentaAlquiler && (
							<Button
								rounded='none'
								w='100%'
								colorScheme='green'
								onClick={() => navigate(`/cruce/pedido/cita/${datos.uuid}`)}
							>
								Cita de venta/alquiler
							</Button>
						)}

						{checkCitaPropuesta && (
							<Button rounded='none' w='100%' colorScheme='purple' onClick={handleOpenPropuesta}>
								Cita de propuesta
							</Button>
						)}

						{checkCitaNotaria && (
							<Button rounded='none' w='100%' colorScheme='red' onClick={handleOpenNotaria}>
								Cita de notaría
							</Button>
						)}
					</Flex>
				)}

				{actividades && actividades.length === 0 && (
					<Text py={6} fontWeight={'bold'} textAlign={'center'}>
						No hay actividades para este pedido
					</Text>
				)}

				{actividades && actividades.length > 0 && (
					<TableContainer maxH='40rem' overflowY='auto'>
						<Table size='sm'>
							<Thead>
								<Tr bgColor='blue.50'>
									<Th>Asunto</Th>
									<Th>Modalidad contacto</Th>
									<Th>Estado</Th>
									<Th>Entidad relacionada</Th>
									<Th>Fecha actividad</Th>
									<Th>Vencimiento</Th>
									<Th>Responsable</Th>
									<Th>Descripción</Th>
								</Tr>
							</Thead>
							<Tbody>
								{actividades.map(actividad => {
									return (
										<Tr key={actividad.uuid} _hover={{ bg: 'gray.100', cursor: 'pointer' }}>
											<Td onClick={() => handleOpenActividad(actividad)}>
												{actividad.tipo_actividad}{' '}
											</Td>
											<Td onClick={() => handleOpenActividad(actividad)}>
												{actividad.modalidad_contacto}
											</Td>
											<Td onClick={() => handleOpenActividad(actividad)}>
												{actividad.estado_actividad}
											</Td>
											<Td onClick={() => handleOpenActividad(actividad)}>
												{actividad.entidad_relacionada}
											</Td>
											<Td onClick={() => handleOpenActividad(actividad)}>
												<EasyDatePicker value={actividad.fecha_actividad} />
											</Td>
											<Td onClick={() => handleOpenActividad(actividad)}>
												<EasyDatePicker value={actividad.fecha_vencimiento} />
											</Td>
											<Td onClick={() => handleOpenActividad(actividad)}>
												{actividad.responsable?.nombre} {actividad.responsable?.apellidos}
											</Td>
											<Td>
												<PopoverDescripcion descripcion={actividad.descripcion} />
											</Td>
										</Tr>
									);
								})}
							</Tbody>
						</Table>
					</TableContainer>
				)}
			</Box>
			{isOpenActualizacion && (
				<ActualizacionModal isOpen={isOpenActualizacion} onClose={onCloseActualizacion} datos={datosRecibidos} isEdit={isEdit} />
			)}

			{isOpenMultiActividad && (
				<MultiActividad isOpen={isOpenMultiActividad} onClose={onCloseMultiActividad} datos={datosRecibidos} isEdit={isEdit} />
			)}
			{isOpenPropuesta && (
				<PropuestaModal isOpen={isOpenPropuesta} onClose={onClosePropuesta} datos={datosRecibidos} isEdit={isEdit} />
			)}
			{isOpenNotaria && (
				<FirmaNotariaModal isOpen={isOpenNotaria} onClose={onCloseNotaria} datos={datosRecibidos} isEdit={isEdit} />
			)}

			{isOpenPropuesta && (
				<PropuestaModal
					isOpen={isOpenPropuesta}
					onClose={onClosePropuesta}
					datos={datosRecibidos}
					isEdit={isEdit}
				/>
			)}
		</>
	);
};

export default ListaActividadesPedidos;
